/* eslint-disable */
import { UserRolesCanAssignUnfulfilledConditionsInfo } from '../dto/user-roles-can-assign-unfulfilled-conditions-info';

export interface UserRolesCanAssignRoleItem {
  internalName: string;
  displayName: string;
  expiresAt: Date | null;
  unfulfilledConditions: UserRolesCanAssignUnfulfilledConditionsInfo | null;
}

export const fixUserRolesCanAssignRoleItemFromJson = (dto?: UserRolesCanAssignRoleItem | null): void => {
  if (!dto) {
    return;
  }
  dto.expiresAt = dto.expiresAt && new Date(dto.expiresAt);
};

export const fixUserRolesCanAssignRoleItemToJson = (dto?: UserRolesCanAssignRoleItem | null): void => {
  if (!dto) {
    return;
  }
};
